<template>
  <div class="SelectHours">
    <div>
      <v-chip
        class="SelectHours-periodSelector"
        :dark="isMorning"
        :color="isMorning ? color : ''"
        @click="isMorning = true"
        >{{ $t('createAppointmentPage.morning') }}</v-chip
      >
      <v-chip
        class="SelectHours-periodSelector"
        :dark="!isMorning"
        :color="!isMorning ? color : ''"
        @click="isMorning = false"
        >{{ $t('createAppointmentPage.afternoon') }}</v-chip
      >
    </div>
    <div class="SelectHours-availlabilities">
      <v-chip
        v-for="(hour, index) in formattedHours"
        :key="index"
        @click="select(hour)"
        class="SelectHours-hour"
        :class="{ 'SelectHours-disabled': isDisabled(hour) }"
        :color="isSelected(hour) ? 'secondary' : ''"
        :disabled="isDisabled(hour)"
      >
        {{ formattedHour(hour) }}
      </v-chip>
    </div>
    <p v-if="!formattedHours.length">{{ $t('createAppointmentPage.noAvailabilities') }}</p>
  </div>
</template>

<script>
import { getMaxRange } from '@/services/time'
export default {
  name: 'SelectHour',
  props: {
    color: {
      type: String,
      default: ''
    },
    currentDay: {
      type: Date,
      default: ''
    },
    defaultSelectedHour: {
      type: Date,
      default: null
    },
    hours: {
      type: Array,
      required: true
    },
    increment: {
      type: Number,
      required: true
    },
    openings: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      selected: this.defaultSelectedHour || '',
      isMorning: true
    }
  },
  computed: {
    currentLocale() {
      return window.navigator.language || window.navigator.languages[0]
    },
    formattedHours() {
      return this.hours.reduce((res, current) => {
        const end = new Date(current[1]).valueOf()
        let currentDate = new Date(current[0]).valueOf()
        const hours = []

        while (currentDate <= end) {
          const date = new Date(currentDate)
          if (this.isMorning && date.getHours() < 13) {
            hours.push(date)
          } else if (!this.isMorning && date.getHours() >= 13) {
            hours.push(date)
          }
          currentDate += this.increment * 3600000
        }
        return [...res, ...hours]
      }, [])
    },
    allHours() {
      if (!this.openings || !this.currentDay) {
        return this.formattedHours
      }
      const dayOfWeek = new Date(this.currentDay).getDay()
      const maxRange = getMaxRange(this.openings, dayOfWeek).map(time => {
        const tmp = new Date(this.currentDay)
        tmp.setHours(time.slice(0, 2))
        tmp.setMinutes(time.slice(3, 4))
        return tmp
      })
      return [maxRange].reduce((res, current) => {
        const end = new Date(current[1]).valueOf()
        let currentDate = new Date(current[0]).valueOf()
        const hours = []

        while (currentDate <= end) {
          hours.push(new Date(currentDate))
          currentDate += this.increment * 3600000
        }

        return [...res, ...hours]
      }, [])
    }
  },
  methods: {
    isDisabled(currentHour) {
      return !this.formattedHours.map(hour => JSON.stringify(hour)).includes(JSON.stringify(currentHour))
    },
    isSelected(hour) {
      return this.selected
        ? this.selected.getHours() === hour.getHours() && this.selected.getMinutes() === hour.getMinutes()
        : false
    },
    select(hour) {
      if (this.isDisabled(hour)) {
        return
      }
      this.$emit('selectHour', hour)
      this.selected = hour
    },
    formattedHour(hour) {
      let _hour = hour instanceof Date ? hour : new Date(hour)
      return _hour
        .toLocaleTimeString(this.$vuetify.lang.current, {
          hour: '2-digit',
          minute: '2-digit'
        })
        .replace(/ [AP]M$/, '')
    }
  }
}
</script>

<style lang="scss">
.SelectHours {
  text-align: center;
}

.SelectHours-hour {
  display: inline-block;
  padding: 0.5em 0.8em;
  margin: 0.4em 1em;
  border-radius: 40px;
  font-size: 0.9rem;
  background-color: var(--v-secondary-lighten2) !important;
  color: var(--v-secondary-base);
  cursor: pointer;
  &:hover {
    background-color: var(--v-secondary-lighten1);
  }
}

.SelectHours-disabled {
  cursor: auto;
  width: 35px;
  padding: 15px;
  color: transparent !important;
  &:hover {
    background-color: var(--v-secondary-lighten2) !important;
  }
}

.SelectHours-availlabilities {
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 1000px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.SelectHours-periodSelector {
  margin: 15px;
  margin-bottom: 40px;
  padding: 15px 20px !important;
  cursor: pointer !important;
  color: var(--v-secondary-base);
  background-color: var(--v-secondary-lighten2) !important;
}
</style>
